<template>
  <div>
    <div class="md-layout md-gutter md-alignment-center-left">
      <div class="md-layout-item md-size-10">
        <md-field>
          <label for="comparador" />
          <md-select
            v-model="comparador"
            name="comparador"
            @md-selected="emitChange"
          >
            <md-option v-for="comp in comparadores" :key="comp" :value="comp">
              {{ comp }}
            </md-option>
          </md-select>
        </md-field>
      </div>
      <div class="md-layout-item md-size-90">
        <termo
          :termo="termoLeft"
          :local-id="localId"
          @change="(e) => changeTermo(e, 'left')"
        />

        <termo
          :termo="termoRight"
          :local-id="localId"
          @change="(e) => changeTermo(e, 'right')"
        />
      </div>
    </div>
  </div>
</template>

<script>
import Termo from './Termo'

export default {
  name: 'Expressao',
  components: { Termo },
  props: {
    localId: {
      type: String,
      required: true,
    },
    expressao: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      comparadores: ['>', '>=', '==', '<', '<='],
      comparador: '>',
      termoLeft: null,
      termoRight: null,
    }
  },
  beforeMount() {
    if (this.expressao && Object.keys(this.expressao).length !== 0) {
      this.comparador = this.expressao.comparador
      this.termoLeft = this.expressao.left
      this.termoRight = this.expressao.right
    }
  },
  methods: {
    changeTermo(data, position) {
      if (position === 'left') {
        this.termoLeft = data
      } else {
        this.termoRight = data
      }

      this.emitChange()
    },
    emitChange() {
      this.$emit('change', {
        left: this.termoLeft,
        right: this.termoRight,
        comparador: this.comparador,
      })
    },
  },
}
</script>

<style lang="scss" scoped></style>
